import Swal from 'sweetalert2';

const CheckInOutMessage = (res) => {
  const [title, ...messages] = res.message.split(':');

  return Swal.fire({
    padding: '0 0 3rem 0',
    title,
    html: messages
      .map(
        (msg) => `
                <p style="
                    font-size:18px;
                    font-weight:500;
                    color:#334155;
                    margin-bottom:2px;
                    line-height:1.6;
                ">
                    ${msg.trim()}
                </p>
            `,
      )
      .join(''),
    icon: res.status,
    timer: 4000,

    showConfirmButton: false,
  });
};

export default CheckInOutMessage;
